<template>
  <el-cascader
    :value="value"
    style="width: 100%"
    :options="options"
    :props="{ checkStrictly: true }"
    @change="handleChange"
    clearable
  ></el-cascader>
</template>

<script>
import { deviceCraftList } from '@/service/getData'

export default {
  props: {
    value: Array,
  },
  data() {
    return {
      options: [],
      loading: false,
    }
  },
  created() {
    this.requestData()
  },
  methods: {
    handleChange(e) {
      this.$emit('input', e)
    },
    async requestData() {
      let data = {
        is_select_option: true,
        size: 500,
      }

      let res = await deviceCraftList(data)
      this.options = res.data.list.map((item) => {
        return {
          value: item.name,
          label: item.name,
          children: item.children.map((item) => {
            return {
              value: item.name,
              label: item.name,
            }
          }),
        }
      })
    },
  },
}
</script>